import React from 'react';

export default (props) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="10" fill="#3751FF" />
        <path d="M5 11L7.92929 13.9293C7.96834 13.9683 8.03166 13.9683 8.07071 13.9293L15 7" stroke="white" strokeWidth="1.7" strokeLinecap="round" />
    </svg>
);
